import PropTypes from 'prop-types';
import { useState } from 'react';
import { documentKinds } from '@heyjob-dash/shared/company/onboarding/model';

import { DescriptionOutlined } from '@mui/icons-material';
import { Box, Card, Alert, Stack, Button, Typography } from '@mui/material';

// Documenti caricati prima delle richieste dello studio: solo consultazione.
export default function OnboardingDocuments({ documents, onDownload }) {
  const [error, setError] = useState('');
  const kinds = documentKinds.filter((kind) => documents.some((file) => file.kind === kind.id));
  if (!kinds.length) return null;
  const download = async (file) => {
    setError('');
    try { await onDownload(file.id); } catch { setError('Non è stato possibile aprire il documento. Riprova.'); }
  };
  return (
    <Card sx={{ p: { xs: 2.5, sm: 3 }, border: '1px solid', borderColor: 'divider', boxShadow: 'none' }}>
      <Stack spacing={2}>
        <Stack spacing={0.5}>
          <Typography variant="subtitle1" component="h2">Documenti caricati in precedenza</Typography>
          <Typography variant="body2" color="text.secondary">Studio li ha già ricevuti: puoi consultarli qui.</Typography>
        </Stack>
        {kinds.map((kind) => (
          <Stack key={kind.id} spacing={1}>
            <Typography variant="subtitle2">{kind.label}</Typography>
            {documents.filter((file) => file.kind === kind.id).map((file) => (
              <Stack key={file.id} direction="row" alignItems="center" justifyContent="space-between" spacing={1.5} sx={{ bgcolor: 'background.neutral', borderRadius: 1, px: 1.5, py: 0.75 }}>
                <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
                  <DescriptionOutlined fontSize="small" sx={{ color: 'text.secondary', flexShrink: 0 }} />
                  <Box component="span" sx={{ overflowWrap: 'anywhere', typography: 'body2' }}>{file.name}</Box>
                </Stack>
                <Button size="small" color="inherit" variant="outlined" onClick={() => download(file)}>Apri</Button>
              </Stack>
            ))}
          </Stack>
        ))}
        {error && <Alert severity="error">{error}</Alert>}
      </Stack>
    </Card>
  );
}
OnboardingDocuments.propTypes = { documents: PropTypes.array.isRequired, onDownload: PropTypes.func.isRequired };
